var appsettings = [
    


        /* PRODUCTION */
        
        {key: "glasschain.app.host.addr", value: "https://observations.glasschain.net"},
        {key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-east.azurewebsites.net"},
        {key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-east.azurewebsites.net"},
        {key: "glasschain.core.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        {key: "glasschain.address.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        {key: "glasschain.translation.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        {key: "glasschain.textrecognition.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        {key: "glasschain.weather.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        {key: "glasschain.translate.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        {key: "glasschain.notification.host.addr", value: "https://gc-notifications-svc-east.azurewebsites.net"},
        {key: "glasschain.data.api.host.addr", value: "https://gc-obs-core-svc.azurewebsites.net"},
        

        /* TEST */
        /*
        {key: "glasschain.app.host.addr", value: "https://observations-test.glasschain.net"},
        {key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-east.azurewebsites.net"},
        {key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-east.azurewebsites.net"},
        {key: "glasschain.core.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.address.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.translation.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.textrecognition.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.weather.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.translate.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        {key: "glasschain.notification.host.addr", value: "https://gc-notifications-svc-east.azurewebsites.net"},
        {key: "glasschain.data.api.host.addr", value: "https://gc-obs-core-test-svc.azurewebsites.net"},
        */

        
        /* DEV */
        /*
        {key: "glasschain.app.host.addr", value: "http://localhost"},
        {key: "glasschain.auth.host.addr", value: "https://gc-auth-svc-east.azurewebsites.net"},
        //{key: "glasschain.auth.host.addr", value: "http://localhost:10001"},
        {key: "glasschain.auth.resource.host.addr", value: "https://gc-auth-mgmt-svc-east.azurewebsites.net"},
        //{key: "glasschain.auth.resource.host.addr", value: "http://localhost:10005"},
    
        {key: "glasschain.core.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.address.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.translation.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.textrecognition.host.addr", value: "http://localhost:6013"},
        {key: "glasschain.weather.host.addr",  value: "http://localhost:6013"},
        {key: "glasschain.translate.host.addr",value: "http://localhost:6013"},
        {key: "glasschain.notification.host.addr", value: "https://gc-notifications-svc-east.azurewebsites.net"},
        {key: "glasschain.data.api.host.addr", value: "http://localhost:6013"},
        */
    


    /* SHARED */
    {key: "base.user.scope", value: ["obs.app.user", "auth.role.reader"]}, 
    {key: "glasschain.api.usebearertoken", value: true},
    {key: "userguide.file.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/{gcid}/userguides/"},
    {key: "userguide.file.name", value: "glasschain-obs-userguide.pdf"},
    {key: "default.email.from.address", value: "support.com"},
    {key: "glasschain.image.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/"},
    {key: "glasschain.image.common.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gc-images/common/"},
    {key: "glasschain.gcid.slide.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.gcid.userimg.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.gcid.userdoc.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.gcid.userrpt.store.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid/"},
    {key: "glasschain.report.host.addr", value: "https://gcblobstoredurable1.blob.core.windows.net/gcid"},
    {key: "lot.watch.interval.milliseconds", value: 30000},
    {key: "system.roles", value: ["bfresh.admin","cbros.admin", "cg.admin", "glassbit.support", "SharedReportViewer",]},
    {key: "system.users", value: ["bfresh.super.admin", "cbros.super.admin", "shared.report.viewer", "dataapitest"]},
    {key: "system.lists", value: []},
    {key: "system.entities", value: []},
    {key: "dataApiRole", value: "ApiDataReader"},
    {key: "geolocation.options", value: {enableHighAccuracy: false, maximumAge: 0, timeout: 10000}},
    {key: 'google.vision.api.key', value: "AIzaSyCjQzBfEZveXkYcCVaoEzKhkaKJCVIfXMw"},
    {key: 'google.vision.api.host.addr', value: "https://vision.googleapis.com"},
    {key: "version", value: "05.11.05"}
]


module.exports = {
    appsettings
}